import React, { useEffect } from 'react'
import AllLaunches from './container/board'
import CreateBlack from './container/create.tsx'
import NotFound from './container/NotFound'
import BuyPage from './container/BuyPage'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { QueryParamProvider } from 'use-query-params'
import { WagmiProvider } from 'wagmi'
import { createAppKit } from '@reown/appkit/react'
import {
  base,
  arbitrum,
  mainnet,
  bsc,
  defineChain
} from '@reown/appkit/networks'
import Profile from './container/Profile.tsx'
import EditProfile from './container/EditProfile'
import toast, { ToastBar, Toaster } from 'react-hot-toast'
import './index.css'
import Faq from './container/Faq'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'
import { http } from 'viem'
import { Analytics } from '@vercel/analytics/react'

const projectId = 'c68344ac2db78dd6f2e70e03015441e6' // Your projectId from your Cloud configuration

const queryClient = new QueryClient()

const SubtensorEVM = defineChain({
  id: 964,
  caipNetworkId: 'eip155:964',
  chainNamespace: 'eip155',
  name: 'Subtensor EVM',
  nativeCurrency: {
    name: 'TAO',
    symbol: 'TAO',
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ['https://lite.chain.opentensor.ai']
    }
  },
  blockExplorers: {
    default: {
      name: 'Taostats Explorer',
      url: 'https://evm.taostats.io'
    }
  },
  contracts: {
    multicall3: {
      address: '0x7ff0FA6200184767F49C8DfF935a7981570D89e1',
      blockCreated: 4658313
    }
  },
  iconUrl: 'https://hotcurves.fun/tao.svg',
  sourceId: 1
})

export const networks = [mainnet, bsc, base, arbitrum, SubtensorEVM]

const metadata = {
  name: 'hotcurves',
  description: 'AI-Powered DeFi Across Chains',
  url: 'https://hotcurves.fun/', // origin must match your domain & subdomain
  icons: [
    'https://imagedelivery.net/_aTEfDRm7z3tKgu9JhfeKA/22caf7db-23c3-4365-c421-5ddf2b5a7200/sm'
  ]
}

export const wagmiAdapter = new WagmiAdapter({
  networks,
  transports: {
    964: http('https://lite.chain.opentensor.ai')
  },
  projectId,
  ssr: true
})

createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId,
  metadata,
  autoConnect: true,
  features: {
    analytics: true // Optional - defaults to your Cloud configuration
  },
  themeVariables: {
    '--w3m-accent': '#f500ff',
    '--w3m-color-mix': '#1e1b2e',
    '--w3m-color-mix-strength': '5'
  }
})

const App = () => {
  useEffect(() => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    const session = localStorage.getItem('walletconnect')
    if (isMobile && !session) {
      const universalLink = `https://reown.app.link/wc?uri=`
      setTimeout(() => {
        const lastUri = localStorage.getItem('WALLETCONNECT_DEEPLINK_CHOICE')
        if (lastUri && lastUri.startsWith('wc:')) {
          window.location.href = `${universalLink}${encodeURIComponent(
            lastUri
          )}`
        }
      }, 500)
    }
  }, [])

  return (
    <WagmiProvider reconnectOnMount config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <Router>
          <QueryParamProvider>
            <div>
              <Toaster
                position="top-right"
                reverseOrder={true}
                toastOptions={{
                  duration: 5000,
                  style: {
                    background: '#333',
                    color: '#fff'
                  }
                }}
              />
              <Switch>
                <Route exact path="/">
                  <AllLaunches />
                </Route>
                {/* <Route exact path="/MyContributions">
                  <MyContributions />
                </Route> */}
                <Route exact path="/board">
                  <AllLaunches />
                </Route>
                <Route exact path="/create">
                  <CreateBlack />
                </Route>
                <Route exact path="/Buy">
                  <BuyPage />
                </Route>
                <Route exact path="/profile">
                  <Profile />
                </Route>
                <Route exact path="/edit">
                  <EditProfile />
                </Route>
                <Route exact path="/faq">
                  <Faq />
                </Route>
                <Route exact path="/NotFound">
                  <NotFound />
                </Route>
              </Switch>
              <Analytics />
            </div>
          </QueryParamProvider>
        </Router>
      </QueryClientProvider>
    </WagmiProvider>
  )
}

export default App
